<template>
  <ul class="about-using-data-list-parts">
    <li v-for="(v, i) in aboutUsingListItems" :key="i" class="about-using-data-list-parts__list">
      <a :href="v.link" target="_blank" class="about-using-data-list-parts__item">
        <span class="about-using-data-list-parts__label" v-html="v.name" />
        <img
          class="about-using-data-list-parts__icon"
          :src="require('@/assets/img/icon/icon_external_link_outline.svg')"
          alt=""
        />
      </a>
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * マイページ: ご利用について データリスト パーツ
 */
export default defineComponent({
  name: 'AboutUsingDataListParts',
  props: {
    /**
     * データリスト
     */
    aboutUsingListItems: {
      type: Array,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.about-using-data-list-parts {
  width: 100%;
  margin-bottom: 24px;
  background: $white;

  &__list {
    &:last-child .about-using-data-list-parts__item {
      padding-bottom: 17px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
  }

  &__item {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 17px 16px 16px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    color: $black80;
    font-weight: 700;
  }

  &__label {
    width: calc(100% - 40px);
    text-align: left;
  }

  &__text {
    width: 108px;
    text-align: right;
    font-size: 13px;
  }
}

@media screen and (min-width: $responsiveMypageMaxWidth) {
  .about-using-data-list-parts {
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    border-right: 1px solid rgba(0, 0, 0, 0.1);
  }
}
</style>
